import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_DETAIL',
        create: 'MARKET_CREATE',
        update: 'MARKET_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_mobile',
        default: '',
        label: this.$t('market_mobile'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'market_password',
        default: '',
        label: this.$t('market_password'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_password,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_password", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.mode === 'create' ? [{
        prop: 'user_name',
        default: '',
        label: this.$t('user_name'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_name", $$v);
              }
            }
          });
        }
      }] : [{
        prop: 'user_name',
        default: '',
        label: this.$t('user_name'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "diabled": true
            },
            "model": {
              value: _this.form.model.user_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'secret',
        default: '',
        label: this.$t('secret'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.secret,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "secret", $$v);
              }
            }
          });
        }
      }]), [{
        prop: 'company',
        default: '',
        label: this.$t('company'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.company,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "company", $$v);
              }
            }
          });
        }
      }]);
    }
  }
};